type Step = 'email_entry' | 'password_entry';
type AuthMethod = 'email' | 'one_time_code' | 'google' | 'facebook';
type InteractionType =
    | 'email_submitted'
    | 'password_submitted'
    | 'social_cta_clicked'
    | 'one_time_code_clicked'
    | 'forgot_password_clicked'
    | 'flow_switch_clicked';
type ErrorType =
    | 'invalid_email_format'
    | 'email_not_found'
    | 'email_already_exists'
    | 'invalid_password'
    | 'weak_password'
    | 'network_error';

interface CiAuth {
    emit(event: 'auth_step_viewed', p: { step: Step }): void;
    emit(
        event: 'auth_interaction',
        p: {
            step: Step;
            interactionType: InteractionType;
            authMethod?: AuthMethod;
        },
    ): void;
    emit(event: 'auth_error', p: { step: Step; authMethod?: AuthMethod; errorType: ErrorType }): void;
}

declare global {
    interface Window {
        ciAuth?: CiAuth;
    }
}

export function stepViewed(step: Step) {
    window.ciAuth?.emit('auth_step_viewed', { step });
}

// Omit `authMethod` unless explicitly provided — `null` is not the same as
// missing on the wire (GA4 surfaces `null` as `(not set)`).
export function interaction(step: Step, interactionType: InteractionType, authMethod?: AuthMethod) {
    const payload: { step: Step; interactionType: InteractionType; authMethod?: AuthMethod } = {
        step,
        interactionType,
    };
    if (authMethod !== undefined) payload.authMethod = authMethod;
    window.ciAuth?.emit('auth_interaction', payload);
}

export function authError(step: Step, errorType: ErrorType, authMethod?: AuthMethod) {
    const payload: { step: Step; errorType: ErrorType; authMethod?: AuthMethod } = { step, errorType };
    if (authMethod !== undefined) payload.authMethod = authMethod;
    window.ciAuth?.emit('auth_error', payload);
}

export {};
